// Bunny CDN optimizer URL helper.
//
// Appends Bunny CDN optimizer params (width/quality/format=webp) to
// gearfocus.b-cdn.net URLs. Extracted verbatim from SafeImage so non-UI code
// (e.g. productCardProps, which is deliberately free of next/image imports so
// jest can transform it) can apply the same optimization without pulling the
// component into its dependency graph. SafeImage now imports this too — one
// source of truth for the Bunny param logic.
//
// Safe in either Bunny Optimizer toggle state: when OFF, params are silently
// ignored and the original is served; when ON, Bunny transforms the image.
// No-op for non-Bunny hosts (GCS, Cloudinary, etc.) and SVG files (rasterizing
// a vector logo to a fixed-width WebP is always a quality loss).
export function getBunnyOptimizedSrc(src: string, targetWidth: number): string {
  if (!src?.includes('gearfocus.b-cdn.net')) return src;
  if (src.toLowerCase().endsWith('.svg')) return src;
  try {
    const url = new URL(src);
    if (url.searchParams.has('width')) return src; // already parameterized by caller
    url.searchParams.set('width', String(targetWidth));
    url.searchParams.set('quality', '80');
    url.searchParams.set('format', 'webp');
    return url.toString();
  } catch {
    return src; // malformed URL → serve unchanged
  }
}
